import React, { FormEvent, useEffect, useState } from "react";
import ReusableDropdown from "../../../../Component/BasicComponents/Dropdowns/Dropdown";
import { Btn } from "../../../../AbstractElements";
import CustomInput from "../../../../Component/BasicComponents/CustomInput";
import ReusableCheckBox from "../../../../Component/BasicComponents/ReusableCheckbox";
import {useALLExpese,useSinlgePurpose,useAddPurpose,useUpdatePurpose,} from "../hooks/useExpense" 
import DualListBox from "../../../../Component/BasicComponents/DualListBox";

interface PurposeFormProps {
  mode: "view" | "edit" | "add" | null;
  handleClose: () => void;
  BID: number | undefined;
}

interface formData {
  title: string;
  Budget: number;
  Notes: string;
  status: number | null;
  Mandatory: boolean;
  purposeRole: number[];
}

type ExpenseApiResponse = {
  ExpenseId: number;
  ExpenseName: string;
};

const PurposeModal: React.FC<PurposeFormProps> = ({mode,handleClose,BID}) => {
  
  
  const intitalState = {
    title: "",
    Budget: 0,
    Notes: "",
    Mandatory: false,
    status: null,
    purposeRole: [],
  };

  const [formdata, setformData] = useState<formData>(intitalState);
  const [btnCount,setbtnCount] = useState(0);
  const purposeBId: any = BID;

  //API
  const { mutate: addPurpose } = useAddPurpose();
  const {mutate:updatePurpose} = useUpdatePurpose();
  const { data, isLoading, isSuccess } = useSinlgePurpose({id: purposeBId,enable: purposeBId ? true : false});

  const {data: dualListData,isLoading: DualListLoading,isSuccess: DualListSuccess,} = useALLExpese({ enable: true });
  const ExpenseRequestData =
    DualListSuccess && Array.isArray(dualListData?.data?.expenseData)
      ? dualListData?.data.expenseData.map(
          (item: ExpenseApiResponse, index: number) => ({
            ExpenseId: item.ExpenseId,
            Title: item.ExpenseName,
          })
        )
      : [];

  useEffect(() => {
    if (isSuccess && data?.data && !isLoading) {
      let purpose = data?.data?.Expenses?.map((item: any) => item?.ExpenseId) || [];
      setformData({
        title: data?.data?.GroupName || "",
        Budget: data?.data?.maxlimit,
        Notes: data?.data?.notes,
        status: data?.data?.status || 0,
        Mandatory: data?.data?.IsDefault,
        purposeRole: purpose,
      });
    }
    if (mode === "add") {
      setformData(intitalState);
    }
    setbtnCount(0);
  }, [isSuccess, BID, mode]);



  const handlePurposeSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const status: number = String(formdata.status) === "Active" ? 1 : 0;

    if (mode === "add") {
      // console.log("form add", formdata);
    setbtnCount(1);
      addPurpose({
        ReqBody: {
          title: formdata.title,
          budget: formdata.Budget,
          notes: formdata.Notes,
          expenses: formdata.purposeRole,
          status: status,
          isDefault: formdata.Mandatory,
        },
      });
      // close modal
      handleClose();
    }else if (mode === "edit") {
      setbtnCount(1);
      // console.log("form edit", formdata);
      updatePurpose({
        ReqBody:{
         "id": Number(BID), // BID  
         "title": formdata.title,
         "budget": formdata.Budget,
         "notes": formdata.Notes,
          "expenses":formdata.purposeRole,
         "status": status,
         "isDefault": formdata.Mandatory
        }
      }) ;

       // close modal
       handleClose();
    }
  };

  const checkboxData = [{label: "Mandatory",value: "mandatory", checked: formdata?.Mandatory || false,}];

  const handleCheckedChangePurposeModal = (checkedItems: any) => {
    // console.log('checkedItems', checkedItems);
    setformData((prev) => ({
      ...prev,
      Mandatory: !prev.Mandatory,
    }));
  };

  const hanleChangeInput = (fieldName: keyof formData,value: string | string[]) => {
    setformData((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  return (
    <form onSubmit={handlePurposeSubmit}>
      <div className="row mb-0">

        <div className="col-md-4 mt-2">
          <CustomInput
          asterisk
            disabled={mode === "view"}
            required={true}
            value={ mode === "edit" ? formdata.title: mode === "view"? formdata.title: formdata.title}
            label="Title"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>hanleChangeInput("title", e.target.value)}
            style={{border: "1px solid #e0e0e0",borderRadius: "4px",}}
          />
        </div>


        <div className="col-md-4 mt-2">
          <CustomInput
            disabled={mode === "view"}
            label="Budget"
            value={ mode === "edit"? formdata.Budget: mode === "view" ? formdata.Budget: formdata.Budget}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              hanleChangeInput("Budget", e.target.value)
            }
            style={{border: "1px solid #e0e0e0",borderRadius: "4px",}}
          />
        </div>

        <div className="col-md-4 mt-2">
          <CustomInput
            disabled={mode === "view"}
            label="Notes"
            value={  mode === "edit" ? formdata.Notes : mode === "view"? formdata.Notes : formdata.Notes }
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => hanleChangeInput("Notes", e.target.value)}
            style={{border: "1px solid #e0e0e0", borderRadius: "4px",}}
          />
        </div>

        <div className="row mb-0">
          <div className="col-md-12 mt-2">
            <DualListBox
             disabled={mode == 'view'}
              // key={JSON.stringify(formdata.purposeRole)}
              DualListLabel="Expense"
              leftOptions={
                !DualListLoading &&
                ExpenseRequestData?.map((item: any) => {
                  return {
                    id: item.ExpenseId,
                    label: item.Title,
                  };
                })
              }
              onSelectionChange={(selected: any) => {
                setformData({
                  ...formdata,
                  ["purposeRole"]: selected?.map((item: any) => item?.id) || [],
                });
              }}
              value={ mode === "edit" || mode === "view"? formdata?.purposeRole : formdata.purposeRole}
              />

            <ReusableDropdown
              disabled={mode === "view"}
              DropdownHeading="Status"
              label={formdata.status == 0 ? "Inactive" : "Active"}
              options={["Active", "Inactive"]}
              onSelect={(option: any) => hanleChangeInput("status", option)}
            />

            <ReusableCheckBox
             disabled={mode === "view"}
              data={checkboxData}
              onCheckedChange={handleCheckedChangePurposeModal}
              style={{padding:'4px',marginTop:'4px'}}/>
          </div>
        </div>
      </div>

      {/* Buttons */}
      <div className="d-flex justify-content-start gap-2 mt-3">
        <Btn
          style={{ backgroundColor: "#43B9B2", color: "white" }}
          type="submit"
          disabled={mode === "view" || btnCount == 1 }>
          Submit
        </Btn>
        <Btn
          type="button"
          onClick={handleClose}
          style={{ backgroundColor: "#F9FAFC", color: "#000" }}>
          Cancel
        </Btn>
      </div>
    </form>
  );
};

export default PurposeModal;
